<template>
    <a-modal title="删除日期标注" :maskClosable="false" @cancel="reset" v-model="isShow" wrapClassName="manage_modal" v-if="data">
        <p style="text-align:center">{{`是否确认删除该标注？`}}</p>
        <template slot="footer">
            <a-button key="submit" type="danger" @click="submit">确认</a-button>
            <a-button key="cancel" @click="reset">取消</a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    props: ['show', 'data'],
    model: {
        prop: 'show',
        event: 'close'
    },
    watch: {
        show() {
            this.isShow=this.show
        }
    },
    data() {
        return {
            isShow:false
        }
    },
    methods: {
        submit() {
            this.$service.deleteData(`${this.$service.api.manage.mark}${this.data.id}/`).then((data)=>{
                this.$message.success('删除成功')
                this.$store.commit('delete_mark', this.data.id)
                this.$emit("reload")
                this.reset()
            })
        },
        reset(){
            this.$emit("close", false)
        }
  },
}
</script>